var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb-2"
  }, [_c('b-form-row', {
    staticClass: "spnod-admin__account--row"
  }, [_c('b-col', [_c('b-form-input', {
    attrs: {
      "name": "firstName",
      "type": "text",
      "placeholder": "First Name"
    },
    model: {
      value: (_vm.parent.firstName),
      callback: function($$v) {
        _vm.$set(_vm.parent, "firstName", $$v)
      },
      expression: "parent.firstName"
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('b-form-input', {
    attrs: {
      "name": "lastName",
      "type": "text",
      "placeholder": "Last Name"
    },
    model: {
      value: (_vm.parent.lastName),
      callback: function($$v) {
        _vm.$set(_vm.parent, "lastName", $$v)
      },
      expression: "parent.lastName"
    }
  })], 1)], 1), _vm._v(" "), _c('b-form-row', {
    staticClass: "spnod-admin__account--row"
  }, [_c('b-col', [_c('b-form-input', {
    attrs: {
      "name": "email",
      "type": "email",
      "placeholder": "Email"
    },
    model: {
      value: (_vm.parent.email),
      callback: function($$v) {
        _vm.$set(_vm.parent, "email", $$v)
      },
      expression: "parent.email"
    }
  })], 1), _vm._v(" "), _c('b-col', [_c('b-form-input', {
    attrs: {
      "name": "phone",
      "type": "text",
      "placeholder": "Phone"
    },
    model: {
      value: (_vm.parent.phone),
      callback: function($$v) {
        _vm.$set(_vm.parent, "phone", $$v)
      },
      expression: "parent.phone"
    }
  })], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6bef6038","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/Forms/ParentFormBasic.vue
// module id = eNp4
// module chunks = 2